import React, { useState, useEffect, useMemo } from 'react';
import Select from "react-select";
import { useTranslation } from "react-i18next";
import DataTable from 'react-data-table-component';
import axios from 'axios';
import { Col, Row, Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import Iframe from 'react-iframe'
import { ToastContainer, toast } from 'react-toastify';
import moment from 'moment';
import { useParams, useNavigate, Link } from "react-router-dom";
import CompLoaderDt from '../Common/CompLoaderDt';

function CompDtOrder() {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const params = useParams();
    let crmId = params.crmId;

    const [componentId] = useState('compDtOrder');
    const [data, setData] = useState(null);

    const [pageNumber, setPageNumber] = useState(0);
    const [pageSize, setPageSize] = useState(5);
    const [sort, setSort] = useState('createDate,DESC');
    const [paginationRowsPerPageOptions] = useState([1, 5, 10, 25, 50, 100]);
    const [totalRows, setTotalRows] = useState(0);


    React.useMemo(() => {
        if (sessionStorage.getItem("currentSession") !== null && sessionStorage.getItem("currentSession")?.bearerToken !== '') {
            if (crmId && crmId) {
                let currentSession = sessionStorage.getItem("currentSession");
                axios.defaults.headers.common["X-User-Language"] = t('language')?.toUpperCase();
                axios.defaults.headers.common["Authorization"] = currentSession !== null ? JSON.parse(currentSession)?.bearerToken : null;
                let ApiGateway = process.env.REACT_APP_API_URL;
                axios.get(ApiGateway + '/market-place/bazaar/sales-order/crm/' + crmId + '/find-and-list?pageNumber=' + pageNumber + '&pageSize=' + pageSize + '&sort=' + sort)
                    .then(response => {
                        if (response.data?.isSucceed === true) {
                            setData(response.data?.payload);
                        }
                    })
                    .catch(error => {
                        console.error(error);
                    });
            }
        }
    }, [t, crmId, pageNumber, pageSize, sort]);


    const [deleteModal, setDeleteModal] = useState(false);
    const [recordId, setRecordId] = useState(false);

    const onGoToItemDetails = props => {
        toast.warn(t('product.common-notification.will-be-develop'));
        //history.push('/product/' + props);
        //dispatch(mpMyCashDeskListApi(props));
    };

    const onBtnDeleteItem = props => {
        let message = 'Prohibited action!';
        toast.error(message, { autoClose: 1000 });
        console.log(props);
        setRecordId(props);
        //setDeleteModal(true);
    };

    const handleDeleteTask = () => {
        if (recordId) {
            //dispatch(mpMyCashDeskDeleteByIdApi({ cashDeskId: recordId }));
            //setDeleteModal(false);
            //dispatch(mpMyCashDeskListApi(pageNumber, pageSize, sort));
            //dispatch(mpMyCashDeskListApi(pageNumber, pageSize, sort));
        }
    };


    useEffect(() => {
        //dispatch(mpMyCashDeskListApi(pageNumber, pageSize, sort));
    }, []);


    const handlePageChange = page => {
        setPageNumber(page - 1);
        //dispatch(mpMyCashDeskListApi(page - 1, pageSize, sort));
    }

    const handlePerRowsChange = async (newPerPage, page) => {
        setPageSize(newPerPage);
        //dispatch(mpMyCashDeskListApi(0, newPerPage, sort));
    }

    const columns = [
        {
            name: <span className='font-weight-bold fs-13'>{t('components.crm.comp-dt-order.dt.th.order-date')}</span>,
            selector: row => moment(row?.latestUpdate).format('DD.MM.YYYY, HH:mm'),
            sortable: false
        },
        {
            name: <span className='font-weight-bold fs-13'>{t('components.crm.comp-dt-order.dt.th.total')}</span>,
            selector: row => row?.total + ' ' + row?.items?.[0]?.cashDesk?.account?.currency?.symbol,
            sortable: false
        },
        {
            name: <span className='font-weight-bold fs-13'>{t('components.crm.comp-dt-order.dt.th.collection-status')}</span>,
            selector: row => row?.status?.label,
            sortable: false
        },
        {
            name: <span className='font-weight-bold fs-13'>{t('components.crm.comp-dt-order.dt.th.actions')}</span>,
            selector: row =>
                <div className="hstack gap-3">
                    {row?.status?.value === "RETRY" ?
                        <button className="btn btn-sm btn-soft-danger remove-list" onClick={() => { onClickCheckout(row.id) }}>
                            <i className="ri-bank-card-fill align-bottom" />
                        </button> :
                        null
                    }
                    {row?.status?.value === "ACCOUNTING_RECEIPT_IS_READY" ?
                        <button className="btn btn-sm btn-soft-info edit-list" onClick={() => { onGoToItemDetails(row.id) }}>
                            <i className="ri-file-text-line align-bottom" />
                        </button> :
                        null
                    }
                </div>,
            sortable: false
        },
    ];

    const [pending, setPending] = useState(true);
    const [rows, setRows] = useState([]);
    useEffect(() => {
        const timeout = setTimeout(() => {
            setRows(data?.content);
            setPending(false);
            setTotalRows(data?.totalElements);
        }, 0);
        return () => clearTimeout(timeout);
    }, [data]);


    //do Payment

    const [referenceId, setReferenceId] = useState('');
    const [apiCalled, setApiCalled] = useState(false);
    const [apiCalledBy, setApiCalledBy] = useState('');

    const [modal, setModal] = useState(false);
    const [modalData, setModalData] = useState(false);
    const toggle = () => setModal(!modal);

    const onLoad = (event) => {
        let browserUrl = event?.target?.contentDocument?.URL;
        if (browserUrl && browserUrl?.includes('/checkout/callback')) {
            toggle();
            let message = t('api.default.service.response.succeded');
            toast.success(message, { autoClose: 1000 });
            const timeout = setTimeout(() => {
                let redirectUrl = '/checkout/callback/' + referenceId;
                window.location.href = redirectUrl;
                navigate(redirectUrl);
            }, 1000);
        }
    }

    const onClickCheckout = (salesOrderId) => {
        setApiCalledBy('Checkout');
        setApiCalled(true);
        if ((sessionStorage.getItem("currentSession") !== null && sessionStorage.getItem("currentSession")?.bearerToken !== '')) {
            let message = t('product.common-notification.please-wait');
            axios.defaults.headers.common["X-User-Language"] = t('language')?.toUpperCase();
            let ApiGateway = process.env.REACT_APP_API_URL;
            setReferenceId(salesOrderId);
            const requestBody = {
                channel: 'CREDIT_CARD',
                referenceSource: 'MARKET_PLACE',
                referenceId: salesOrderId,
            };
            axios.post(ApiGateway + '/finance/payment/do-payment', requestBody)
                .then(response2 => {
                    let payload = response2.data?.payload;
                    let description = '';
                    if (payload?.succeeded) {
                        description = payload?.description
                        setApiCalled(false);
                    } else {
                        response2.data?.messages?.forEach(
                            item => toast.error(item.message, { autoClose: 5000 })
                        )
                        setApiCalled(false);
                    }
                    if (description !== '') {
                        setModalData(description);
                        toggle();
                    }
                    //setData(response2.data);
                    //let redirectUrl = '/basket';
                    //window.location.href = redirectUrl;
                })
                .catch(error => {
                    console.error(error);
                    setApiCalled(false);
                });
        }
    }


    return (
        <React.Fragment>
            <ToastContainer />
            <Row>
                <Col lg={12}>
                    <div>
                        <Modal isOpen={modal} toggle={toggle} size="xl" >
                            <ModalHeader toggle={toggle}>{t('components.crm.comp-dt-order.modal.title')}</ModalHeader>
                            <ModalBody>
                                <Iframe url={modalData + '&iframe=true'}
                                    onLoad={onLoad}
                                    width="100%"
                                    height="100%"
                                    styles={{ height: "700px" }}
                                    id=""
                                    className=""
                                    display="block"
                                    position="relative" />
                            </ModalBody>
                            <ModalFooter>
                                <Button color="dark" onClick={toggle}>
                                    {t('components.crm.comp-dt-order.modal.form.button.close')}
                                </Button>
                            </ModalFooter>
                        </Modal>
                    </div>
                </Col>
            </Row>
            {data ? ((
                <DataTable
                    id={componentId}
                    columns={columns}
                    data={rows}
                    pagination={true}
                    paginationServer
                    onPageChange={page => setPageNumber(page)}
                    paginationPerPage={pageSize}
                    paginationTotalRows={totalRows}
                    onChangePage={handlePageChange}
                    onChangeRowsPerPage={handlePerRowsChange}
                    progressPending={pending}
                    noDataComponent={t('data-table.label.no-data')}
                    paginationRowsPerPageOptions={paginationRowsPerPageOptions}
                    paginationComponentOptions={{
                        rowsPerPageText: t('data-table.label.rows-per-page'),
                        rangeSeparatorText: t('data-table.label.out-of'),
                    }}
                />
            )) : (
                <Row>
                    <Col className={"col-md-12 text-center"}>
                        <CompLoaderDt />
                    </Col>
                </Row>
            )}
        </React.Fragment>
    );
}
export default CompDtOrder;